import { jsx as _jsx } from "react/jsx-runtime";
import StyledCard from "./CardBase.styles";
import { CardBaseVariants } from "./constants";
const CardBase = ({ children = [], variant = CardBaseVariants.default, hasHover = true, selected = false, onClick = () => { }, }) => {
    return (_jsx(StyledCard, { selected: selected, variant: variant, onClick: onClick, hasHover: hasHover, children: children }));
};
export default CardBase;
//# sourceMappingURL=CardBase.js.map